function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import App from 'modules/App';
import { formatDate } from 'helpers/datetime';
import intlShape from 'shapes/intlShape';
import messages from '../../../messages';
import styles from './Header.pcss';
import Legend from './Legend';
var _React_Component;
class Header extends (_React_Component = React.Component) {
    render() {
        const { accountPatientProfile, phiSet, conversion, startDate, endDate } = this.props;
        if (!accountPatientProfile || !phiSet) return null;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.headerDailyLogReport,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                children: `${accountPatientProfile.firstName} ${accountPatientProfile.lastName}`
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.diabetesType)}: ${App.messages.diabetesTypes[phiSet.diabetesType] ? `${this.props.intl.formatMessage(App.messages.diabetesTypes[phiSet.diabetesType])}` : '-'}`
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.treatmentType)}: ${App.messages.treatmentTypes[phiSet.treatmentType] ? `${this.props.intl.formatMessage(App.messages.treatmentTypes[phiSet.treatmentType])}` : '-'}`
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.dateOfBirth)}: 
              ${accountPatientProfile.dateOfBirth ? formatDate(accountPatientProfile.dateOfBirth) : '-'}`
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: accountPatientProfile.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.headerDailyLogReport__title,
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.title))
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.dailyLogReport__date,
                                children: `${formatDate(startDate)} - ${formatDate(endDate)}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Legend, {
                            conversion: conversion
                        })
                    })
                ]
            })
        });
    }
}
_define_property(Header, "propTypes", {
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit props
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    conversion: PropTypes.object.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object
});
export default withStyles(styles)(injectIntl(Header));
